import styles from './fun.module.css';
import classNames from 'classnames';
import { MouseIcon } from '~/svgs/common';
import { motion } from 'framer-motion';
import TitledPill from '../common/titled-pill';
import { RocketIcon, Hands } from '~/svgs/about-page';
import { NextLink, Translate } from '~/i18n';

const texts = [
   <Translate key={1} id="about:discover" />,
   <Translate key={2} id="about:book" />,
   <Translate key={3} id="about:plan" />,
   <Translate key={4} id="about:organize" />,
   <Translate key={5} id="about:insights" />,
];

const FunSection = () => {
   return (
      <div className="text-center mb-16">
         <span className="font-black uppercase italic text-3xl mt-16 -mb-8 md:mb-8 lg:mb-16 block">
            <Translate id="about:we are all about" />
         </span>
         <div
            dir="ltr"
            className="inline-flex justify-center relative ltr:pl-6 lg:mb-24 transform scale-40 small:scale-50 md:scale-75 lg:scale-100">
            <img
               src="/images/about-page/f.png"
               alt="F"
               className={classNames(styles.f, '-ml-6 small:ml-0 -mr-6 z-10')}
            />
            <img src="/images/about-page/u.png" alt="U" className={classNames(styles.u, 'mr-2')} />
            <img src="/images/about-page/n.png" alt="N" className={classNames(styles.n)} />
            <img
               src="/images/about-page/ali.png"
               alt="person wearing thobe jumping"
               className={classNames(styles.u, styles.ali, 'absolute z-20')}
            />
            <img
               src="/images/about-page/who.png"
               alt="person wearing casual clothes jumping"
               className={classNames(styles.u, styles.who, 'left-0 absolute z-20')}
            />
         </div>

         <div className="mb-6 -mt-10 md:mt-6">
            <div className="md:w-2/3 lg:rtl:w-3/5 lg:ltr:w-2/3 xl:ltr:w-3/5 mx-auto">
               <div className="flex justify-center md:justify-between space-x-4 lg:ltr:space-x-8 rtl:space-x-8 rtl:space-x-reverse text-center">
                  {texts.map((text, index) => (
                     <motion.div
                        initial={{ opacity: 0, y: 25 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: 0.15 * index, ease: 'anticipate' }}
                        key={index}
                        className="md:ltr:text-base lg:rtl:text-lg xs:rtl:text-base ltr:text-xs rtl:text-sm small:ltr:tracking-widest text-primary-color">
                        {text}
                     </motion.div>
                  ))}
               </div>
            </div>
         </div>
         <a href="#app" className="inline-block">
            <div className="hidden hover:bg-primary-disabled rounded-xl sm:flex justify-center mb-10 lg:mt-6">
               <MouseIcon />
            </div>
         </a>

         <div className="flex justify-center">
            <div className="grid md:grid-cols-2 gap-6 md:gap-20 lg:gap-40">
               <NextLink href="/business">
                  <TitledPill
                     icon={<RocketIcon />}
                     title={<Translate id="about:hy businesses" />}
                     description={<Translate id="about:discover solutions" />}
                  />
               </NextLink>
               <a
                  href="https://halayalla.com/halayalla-business/invest-in-apps.php"
                  rel="noreferrer"
                  target="_blank">
                  <TitledPill
                     icon={<Hands />}
                     title={<Translate id="about:investor relations" />}
                     description={<Translate id="about:read investor relations" />}
                  />
               </a>
            </div>
         </div>
      </div>
   );
};

export default FunSection;
